
import Vue from 'vue'

export default Vue.extend({
  name: 'All',
  components: {
    Checkbox: () => import('primevue/checkbox'),
    InputText: () => import('primevue/inputtext'),
    Button: () => import('primevue/button')
  },
  layout: 'footer',
  async asyncData({ $axios, params }) {
    const routeParam = params.wp
    let companies = []

    if (routeParam === 'companies') {
      const companiesRes = await $axios.get('/proxysbapi/home/featured-companies')
      companies = companiesRes.data
    }

    return {
      companies,
      filteredCompanies: companies
    }
  },
  data() {
    return {
      companies: [],
      search: {
        text: '',
        city: '',
        open: false
      },
      filteredCompanies: []
    }
  },
  computed: {
    openPositions() {
      return this.search.open
        ? this.filteredCompanies.filter(company => company.company.countJobs > 0)
        : this.filteredCompanies
    }
  },
  watch: {
    'search.city'(newValue, oldValue) {
      if (!newValue && oldValue) {
        this.searchMethod()
      }
    }
  },
  methods: {
    searchMethod() {
      const searchText = this.search.text.toLowerCase()
      const searchCity = this.search.city.toLowerCase()

      if (searchText) {
        this.filteredCompanies = this.companies.filter(company =>
          company.company.name.toLowerCase().includes(searchText)
        )
      } else {
        this.filteredCompanies = this.companies
      }

      if (searchCity) {
        this.filteredCompanies = this.filteredCompanies.filter(company =>
          company?.company?.city?.toLowerCase().includes(searchCity)
        )
      }
    }
  }
})
